import { render } from "./GalleryActionsDropdown.vue?vue&type=template&id=00e9fc48&scoped=true"
import script from "./GalleryActionsDropdown.vue?vue&type=script&lang=js"
export * from "./GalleryActionsDropdown.vue?vue&type=script&lang=js"

import "./GalleryActionsDropdown.vue?vue&type=style&index=0&id=00e9fc48&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00e9fc48"]])

export default __exports__